import md5 from "blueimp-md5";

// Generate ID based on unique string
export const idFor = string => {
  return md5(string);
};
